import { useDispatch, useSelector } from 'react-redux'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import { Link } from 'react-router-dom'

import Brightness4Icon from '@mui/icons-material/Brightness4'
import Brightness7Icon from '@mui/icons-material/Brightness7'
import { useTheme } from '@mui/material/styles'

import { setColorMode } from '../../actions/viewerActions'

import { classes, ToolBarStyle } from './style'
import Typography from '@mui/material/Typography'

// eslint-disable-next-line react/prop-types
const ToolBar = ({ children }) => {
  const dispatch = useDispatch()

  const theme = useTheme()
  const colorMode = useSelector(state => state.viewer.colorMode)

  const toggleMode = () => {
    const mode = colorMode === 'light' ? 'dark' : 'light'
    dispatch(setColorMode(mode))
  }

  return (
        <ToolBarStyle sx={{ flexGrow: 1 }} className={classes.root} >
            <AppBar position="static" >
                <Toolbar className={classes.toolBar}>
                  <Link to={'/'} className={classes.contentTitle}>
                    <Typography className={classes.title}>Upcree</Typography>
                  </Link>

                  <div>{children}</div>
                  <div>

                        <IconButton
                            color="inherit"
                            sx={{ ml: 1 }}
                            onClick={() => toggleMode()}
                            style={{ color: 'gray' }}
                        >
                            {theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
                        </IconButton>

                    </div>

                </Toolbar>
            </AppBar>
        </ToolBarStyle>

  )
}

export default ToolBar
